export default __webpack_public_path__ + "static/media/Broadform-building-insurance-policy-2025.f2a782cd.pdf";